import React from 'react';
import PropTypes from 'prop-types';
import Chart from 'chart.js';
import moment from "moment";
import _ from 'lodash';
import './StateStatsChart.css';

export default class StateStatsChart extends React.Component {

    static propTypes = {
        state: PropTypes.object.isRequired,
        entrances: PropTypes.array.isRequired,
        exits: PropTypes.array.isRequired,
        itemCount: PropTypes.number.isRequired
    };

    static defaultProps = {};

    constructor(props) {
        super(props);
        this.canvas = null;
        this.state = {};
    }

    componentDidMount() {
        let max = moment().add(1, 'hour').startOf('hour');
        let min = max.clone().subtract(7, 'days');
        let integralData = [];
        let entrancesData = [];
        let entrancesByDate = {};
        let exitsData = [];
        let exitsByDate = {};

        this.props.entrances.forEach(entrance => {
            entrancesByDate[entrance.date] = entrance.count;
        });

        this.props.exits.forEach(exit => {
            exitsByDate[exit.date] = exit.count;
        });

        let sum = this.props.itemCount;
        for (let m = max.clone(); m.isSameOrAfter(min); m.subtract(1, 'hours')) {
            let date = m.utc().format('YYYY-MM-DDTHH:mm:ss[Z]');
            let entranceCount = 0;
            let existCount = 0;
            // Update the integralData before we change the sum because we are going backwards in time
            integralData.push({
                x: date,
                y: sum
            });
            if (_.has(entrancesByDate, date)) {
                entranceCount = entrancesByDate[date];
                sum -= entranceCount;
            }
            if (_.has(exitsByDate, date)) {
                existCount = -exitsByDate[date];
                sum -= existCount;
            }
            entrancesData.push({
                x: date,
                y: entranceCount
            });
            exitsData.push({
                x: date,
                y: existCount
            });
        }

        _.reverse(integralData);
        _.reverse(entrancesData);
        _.reverse(exitsData);

        this.chart = new Chart(this.canvas, {
            type: 'bar',
            data: {
                datasets: [{
                    type: 'line',
                    label: "Total Items",
                    xAxisID: 'time-x-axis',
                    yAxisID: 'total-y-axis',
                    fill: false,
                    cubicInterpolationMode: 'monotone',
                    borderColor: 'rgb(255, 99, 132)',
                    data: integralData,
                }, {
                    type: 'bar',
                    label: 'Items Entered',
                    backgroundColor: 'rgba(244, 72, 72, 0.5)',
                    xAxisID: 'time-x-axis',
                    yAxisID: 'enter-exit-y-axis',
                    data: entrancesData
                }, {
                    type: 'bar',
                    label: 'Items Exited',
                    backgroundColor: 'rgba(129, 244, 72, 0.5)',
                    xAxisID: 'time-x-axis',
                    yAxisID: 'enter-exit-y-axis',
                    data: exitsData
                }]
            },
            options: {
                maintainAspectRatio: false,
                elements: {
                    point: {
                        radius: 2
                    },
                },
                scales: {
                    xAxes: [{
                        id: 'time-x-axis',
                        type: 'time',
                        stacked: true,
                        time: {
                            unit: 'day',
                            max: max,
                            min: min,
                            round: true,
                            tooltipFormat: 'MMM D HH:mm',
                            displayFormats: {
                                hour: 'HH:mm',
                                day: 'MMM D'
                            },
                            stepSize: 1
                        },
                        gridLines: {
                            offsetGridLines: false
                        }
                    }],
                    yAxes: [{
                        id: 'total-y-axis',
                        type: 'linear',
                        position: 'left'
                    }, {
                        id: 'enter-exit-y-axis',
                        type: 'linear',
                        position: 'right'
                    }]
                }
            }
        });
    }

    render() {
        return (
            <div className="stateStatsChart material">
                <div>{this.props.state.name}</div>
                <canvas ref={elm => this.canvas = elm} style={{height: 260}}/>
            </div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/analytics/StateStatsChart.js